//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IMessageServiceClient {
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    actionCard(x_api_key: string | undefined, body: ActionCardDto | undefined): Promise<void>;
    /**
     * @param templateId (optional) 
     * @param userId (optional) 
     * @param x_api_key (optional) 
     * @return Success
     */
    discard(templateId: string | undefined, userId: string | undefined, x_api_key: string | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    consentsAllGET(x_api_key: string | undefined): Promise<ConsentTypeGroupDto[]>;
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    consentsAllPUT(x_api_key: string | undefined, body: ConsentTypeUpdateDto[] | undefined): Promise<ConsentTypeUpdateDto[]>;
    /**
     * @param consentStatusEnum (optional) 
     * @param x_api_key (optional) 
     * @return Success
     */
    consents(consentStatusEnum: AnswerConsentStatusEnum | undefined, x_api_key: string | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    verifyBounceStatus(x_api_key: string | undefined): Promise<VerifyBounceStatusResponse>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    ignoreBounce(x_api_key: string | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    checkIsEmailVerified(x_api_key: string | undefined): Promise<boolean>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    sendConfirmEmail(x_api_key: string | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    shouldFetch(x_api_key: string | undefined): Promise<ShouldFetchNewPushPermissionDto>;
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    notification(x_api_key: string | undefined, body: AddNotificationDto | undefined): Promise<number>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    settingsEmailAllGET(x_api_key: string | undefined): Promise<SettingsMessageTypeGroupDto[]>;
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    settingsEmailAllPUT(x_api_key: string | undefined, body: CustomerSettingUpdateDto[] | undefined): Promise<CustomerSettingUpdateDto[]>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    settingsEmail(messageTypeId: number, x_api_key: string | undefined): Promise<UnsubscribeMessageTypeDto>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    settingsGET(x_api_key: string | undefined): Promise<SettingsMessageTypeGroupDto[]>;
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    settingsPUT(x_api_key: string | undefined, body: CustomerSettingUpdateDto[] | undefined): Promise<CustomerSettingUpdateDto[]>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    token(x_api_key: string | undefined): Promise<string>;
    /**
     * @param eventType (optional) 
     * @param x_api_key (optional) 
     * @return Success
     */
    event(eventType: ConversionEvent | undefined, x_api_key: string | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    verify(x_api_key: string | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    emailSubscribe(x_api_key: string | undefined, body: IterableWebhookSubscribePayload | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    emailUnsubscribe(x_api_key: string | undefined, body: IterableWebhookUnsubscribePayload | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    emailBounce(x_api_key: string | undefined, body: IterableWebhookBouncePayload | undefined): Promise<void>;
    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    pushNotification(x_api_key: string | undefined, body: IterableWebhookPushNotificationPayload | undefined): Promise<void>;
}

export class MessageServiceClient implements IMessageServiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    actionCard(x_api_key: string | undefined, body: ActionCardDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ActionCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActionCard(_response);
        });
    }

    protected processActionCard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param templateId (optional) 
     * @param userId (optional) 
     * @param x_api_key (optional) 
     * @return Success
     */
    discard(templateId: string | undefined, userId: string | undefined, x_api_key: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ActionCard/discard?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscard(_response);
        });
    }

    protected processDiscard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    consentsAllGET(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<ConsentTypeGroupDto[]> {
        let url_ = this.baseUrl + "/Consents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConsentsAllGET(_response);
        });
    }

    protected processConsentsAllGET(response: AxiosResponse): Promise<ConsentTypeGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsentTypeGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConsentTypeGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsentTypeGroupDto[]>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    consentsAllPUT(x_api_key: string | undefined, body: ConsentTypeUpdateDto[] | undefined, cancelToken?: CancelToken): Promise<ConsentTypeUpdateDto[]> {
        let url_ = this.baseUrl + "/Consents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConsentsAllPUT(_response);
        });
    }

    protected processConsentsAllPUT(response: AxiosResponse): Promise<ConsentTypeUpdateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsentTypeUpdateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConsentTypeUpdateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsentTypeUpdateDto[]>(null as any);
    }

    /**
     * @param consentStatusEnum (optional) 
     * @param x_api_key (optional) 
     * @return Success
     */
    consents(consentStatusEnum: AnswerConsentStatusEnum | undefined, x_api_key: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Consents?";
        if (consentStatusEnum === null)
            throw new Error("The parameter 'consentStatusEnum' cannot be null.");
        else if (consentStatusEnum !== undefined)
            url_ += "consentStatusEnum=" + encodeURIComponent("" + consentStatusEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConsents(_response);
        });
    }

    protected processConsents(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    verifyBounceStatus(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<VerifyBounceStatusResponse> {
        let url_ = this.baseUrl + "/Mail/verify-bounce-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyBounceStatus(_response);
        });
    }

    protected processVerifyBounceStatus(response: AxiosResponse): Promise<VerifyBounceStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifyBounceStatusResponse.fromJS(resultData200);
            return Promise.resolve<VerifyBounceStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerifyBounceStatusResponse>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    ignoreBounce(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Mail/ignore-bounce";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIgnoreBounce(_response);
        });
    }

    protected processIgnoreBounce(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    checkIsEmailVerified(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Mail/check-is-email-verified";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIsEmailVerified(_response);
        });
    }

    protected processCheckIsEmailVerified(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    sendConfirmEmail(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Mail/send-confirm-email";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendConfirmEmail(_response);
        });
    }

    protected processSendConfirmEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    shouldFetch(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<ShouldFetchNewPushPermissionDto> {
        let url_ = this.baseUrl + "/Notification/should-fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShouldFetch(_response);
        });
    }

    protected processShouldFetch(response: AxiosResponse): Promise<ShouldFetchNewPushPermissionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShouldFetchNewPushPermissionDto.fromJS(resultData200);
            return Promise.resolve<ShouldFetchNewPushPermissionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShouldFetchNewPushPermissionDto>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    notification(x_api_key: string | undefined, body: AddNotificationDto | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotification(_response);
        });
    }

    protected processNotification(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    settingsEmailAllGET(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<SettingsMessageTypeGroupDto[]> {
        let url_ = this.baseUrl + "/web/settings-email";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingsEmailAllGET(_response);
        });
    }

    protected processSettingsEmailAllGET(response: AxiosResponse): Promise<SettingsMessageTypeGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingsMessageTypeGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SettingsMessageTypeGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingsMessageTypeGroupDto[]>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    settingsEmailAllPUT(x_api_key: string | undefined, body: CustomerSettingUpdateDto[] | undefined, cancelToken?: CancelToken): Promise<CustomerSettingUpdateDto[]> {
        let url_ = this.baseUrl + "/web/settings-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingsEmailAllPUT(_response);
        });
    }

    protected processSettingsEmailAllPUT(response: AxiosResponse): Promise<CustomerSettingUpdateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerSettingUpdateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerSettingUpdateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSettingUpdateDto[]>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    settingsEmail(messageTypeId: number, x_api_key: string | undefined, cancelToken?: CancelToken): Promise<UnsubscribeMessageTypeDto> {
        let url_ = this.baseUrl + "/web/settings-email/{messageTypeId}";
        if (messageTypeId === undefined || messageTypeId === null)
            throw new Error("The parameter 'messageTypeId' must be defined.");
        url_ = url_.replace("{messageTypeId}", encodeURIComponent("" + messageTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingsEmail(_response);
        });
    }

    protected processSettingsEmail(response: AxiosResponse): Promise<UnsubscribeMessageTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnsubscribeMessageTypeDto.fromJS(resultData200);
            return Promise.resolve<UnsubscribeMessageTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnsubscribeMessageTypeDto>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    settingsGET(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<SettingsMessageTypeGroupDto[]> {
        let url_ = this.baseUrl + "/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingsGET(_response);
        });
    }

    protected processSettingsGET(response: AxiosResponse): Promise<SettingsMessageTypeGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingsMessageTypeGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SettingsMessageTypeGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingsMessageTypeGroupDto[]>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    settingsPUT(x_api_key: string | undefined, body: CustomerSettingUpdateDto[] | undefined, cancelToken?: CancelToken): Promise<CustomerSettingUpdateDto[]> {
        let url_ = this.baseUrl + "/Settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingsPUT(_response);
        });
    }

    protected processSettingsPUT(response: AxiosResponse): Promise<CustomerSettingUpdateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerSettingUpdateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerSettingUpdateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSettingUpdateDto[]>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    token(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param eventType (optional) 
     * @param x_api_key (optional) 
     * @return Success
     */
    event(eventType: ConversionEvent | undefined, x_api_key: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Tracking/event?";
        if (eventType === null)
            throw new Error("The parameter 'eventType' cannot be null.");
        else if (eventType !== undefined)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEvent(_response);
        });
    }

    protected processEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    verify(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Verify";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    emailSubscribe(x_api_key: string | undefined, body: IterableWebhookSubscribePayload | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Webhooks/email-subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailSubscribe(_response);
        });
    }

    protected processEmailSubscribe(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    emailUnsubscribe(x_api_key: string | undefined, body: IterableWebhookUnsubscribePayload | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Webhooks/email-unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailUnsubscribe(_response);
        });
    }

    protected processEmailUnsubscribe(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    emailBounce(x_api_key: string | undefined, body: IterableWebhookBouncePayload | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Webhooks/email-bounce";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailBounce(_response);
        });
    }

    protected processEmailBounce(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @param body (optional) 
     * @return Success
     */
    pushNotification(x_api_key: string | undefined, body: IterableWebhookPushNotificationPayload | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Webhooks/push-notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushNotification(_response);
        });
    }

    protected processPushNotification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ActionCardDto implements IActionCardDto {
    notificationId!: string;
    jwtToken!: string | undefined;

    constructor(data?: IActionCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.jwtToken = _data["jwtToken"];
        }
    }

    static fromJS(data: any): ActionCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["jwtToken"] = this.jwtToken;
        return data;
    }
}

export interface IActionCardDto {
    notificationId: string;
    jwtToken: string | undefined;
}

export class AddNotificationDto implements IAddNotificationDto {
    token!: string | undefined;
    deviceId!: string | undefined;
    customerId!: number;

    constructor(data?: IAddNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.deviceId = _data["deviceId"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): AddNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["deviceId"] = this.deviceId;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IAddNotificationDto {
    token: string | undefined;
    deviceId: string | undefined;
    customerId: number;
}

export enum AnswerConsentStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ConsentTypeDto implements IConsentTypeDto {
    name!: string | undefined;
    dataFieldName!: string | undefined;
    visibleTitle!: string | undefined;
    customerConsents!: CustomerConsentsDto | undefined;

    constructor(data?: IConsentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.customerConsents = data.customerConsents && !(<any>data.customerConsents).toJSON ? new CustomerConsentsDto(data.customerConsents) : <CustomerConsentsDto>this.customerConsents;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dataFieldName = _data["dataFieldName"];
            this.visibleTitle = _data["visibleTitle"];
            this.customerConsents = _data["customerConsents"] ? CustomerConsentsDto.fromJS(_data["customerConsents"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataFieldName"] = this.dataFieldName;
        data["visibleTitle"] = this.visibleTitle;
        data["customerConsents"] = this.customerConsents ? this.customerConsents.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConsentTypeDto {
    name: string | undefined;
    dataFieldName: string | undefined;
    visibleTitle: string | undefined;
    customerConsents: ICustomerConsentsDto | undefined;
}

export class ConsentTypeGroupDto implements IConsentTypeGroupDto {
    name!: string | undefined;
    description!: string | undefined;
    consentTypes!: ConsentTypeDto[] | undefined;

    constructor(data?: IConsentTypeGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.consentTypes) {
                this.consentTypes = [];
                for (let i = 0; i < data.consentTypes.length; i++) {
                    let item = data.consentTypes[i];
                    this.consentTypes[i] = item && !(<any>item).toJSON ? new ConsentTypeDto(item) : <ConsentTypeDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["consentTypes"])) {
                this.consentTypes = [] as any;
                for (let item of _data["consentTypes"])
                    this.consentTypes!.push(ConsentTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsentTypeGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentTypeGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.consentTypes)) {
            data["consentTypes"] = [];
            for (let item of this.consentTypes)
                data["consentTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConsentTypeGroupDto {
    name: string | undefined;
    description: string | undefined;
    consentTypes: IConsentTypeDto[] | undefined;
}

export class ConsentTypeUpdateDto implements IConsentTypeUpdateDto {
    customerConsentId!: number;
    optStatus!: OptStatusEnum;
    updated!: boolean;
    dataFieldName!: string | undefined;

    constructor(data?: IConsentTypeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerConsentId = _data["customerConsentId"];
            this.optStatus = _data["optStatus"];
            this.updated = _data["updated"];
            this.dataFieldName = _data["dataFieldName"];
        }
    }

    static fromJS(data: any): ConsentTypeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentTypeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerConsentId"] = this.customerConsentId;
        data["optStatus"] = this.optStatus;
        data["updated"] = this.updated;
        data["dataFieldName"] = this.dataFieldName;
        return data;
    }
}

export interface IConsentTypeUpdateDto {
    customerConsentId: number;
    optStatus: OptStatusEnum;
    updated: boolean;
    dataFieldName: string | undefined;
}

export enum ConversionEvent {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CustomerConsentsDto implements ICustomerConsentsDto {
    id!: number;
    optStatus!: OptStatusEnum;

    constructor(data?: ICustomerConsentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.optStatus = _data["optStatus"];
        }
    }

    static fromJS(data: any): CustomerConsentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConsentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["optStatus"] = this.optStatus;
        return data;
    }
}

export interface ICustomerConsentsDto {
    id: number;
    optStatus: OptStatusEnum;
}

export class CustomerSettingUpdateDto implements ICustomerSettingUpdateDto {
    optStatus!: OptStatusEnum;
    customerSettingId!: number;
    updated!: boolean;
    messageTypeId!: number;

    constructor(data?: ICustomerSettingUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optStatus = _data["optStatus"];
            this.customerSettingId = _data["customerSettingId"];
            this.updated = _data["updated"];
            this.messageTypeId = _data["messageTypeId"];
        }
    }

    static fromJS(data: any): CustomerSettingUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSettingUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optStatus"] = this.optStatus;
        data["customerSettingId"] = this.customerSettingId;
        data["updated"] = this.updated;
        data["messageTypeId"] = this.messageTypeId;
        return data;
    }
}

export interface ICustomerSettingUpdateDto {
    optStatus: OptStatusEnum;
    customerSettingId: number;
    updated: boolean;
    messageTypeId: number;
}

export class CustomerSettingsDto implements ICustomerSettingsDto {
    id!: number;
    optStatus!: OptStatusEnum;

    constructor(data?: ICustomerSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.optStatus = _data["optStatus"];
        }
    }

    static fromJS(data: any): CustomerSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["optStatus"] = this.optStatus;
        return data;
    }
}

export interface ICustomerSettingsDto {
    id: number;
    optStatus: OptStatusEnum;
}

export class IterableWebhookBounceDataField implements IIterableWebhookBounceDataField {
    emailSubject!: string | undefined;
    campaignName!: string | undefined;
    workflowId!: string | undefined;
    workflowName!: string | undefined;
    templateName!: string | undefined;
    channelId!: number;
    messageTypeId!: number;
    experimentId!: number;
    recipientState!: string | undefined;
    templateId!: number;
    email!: string | undefined;
    createdAt!: string | undefined;
    campaignId!: number;
    messageId!: string | undefined;
    emailId!: string | undefined;

    constructor(data?: IIterableWebhookBounceDataField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailSubject = _data["emailSubject"];
            this.campaignName = _data["campaignName"];
            this.workflowId = _data["workflowId"];
            this.workflowName = _data["workflowName"];
            this.templateName = _data["templateName"];
            this.channelId = _data["channelId"];
            this.messageTypeId = _data["messageTypeId"];
            this.experimentId = _data["experimentId"];
            this.recipientState = _data["recipientState"];
            this.templateId = _data["templateId"];
            this.email = _data["email"];
            this.createdAt = _data["createdAt"];
            this.campaignId = _data["campaignId"];
            this.messageId = _data["messageId"];
            this.emailId = _data["emailId"];
        }
    }

    static fromJS(data: any): IterableWebhookBounceDataField {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookBounceDataField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailSubject"] = this.emailSubject;
        data["campaignName"] = this.campaignName;
        data["workflowId"] = this.workflowId;
        data["workflowName"] = this.workflowName;
        data["templateName"] = this.templateName;
        data["channelId"] = this.channelId;
        data["messageTypeId"] = this.messageTypeId;
        data["experimentId"] = this.experimentId;
        data["recipientState"] = this.recipientState;
        data["templateId"] = this.templateId;
        data["email"] = this.email;
        data["createdAt"] = this.createdAt;
        data["campaignId"] = this.campaignId;
        data["messageId"] = this.messageId;
        data["emailId"] = this.emailId;
        return data;
    }
}

export interface IIterableWebhookBounceDataField {
    emailSubject: string | undefined;
    campaignName: string | undefined;
    workflowId: string | undefined;
    workflowName: string | undefined;
    templateName: string | undefined;
    channelId: number;
    messageTypeId: number;
    experimentId: number;
    recipientState: string | undefined;
    templateId: number;
    email: string | undefined;
    createdAt: string | undefined;
    campaignId: number;
    messageId: string | undefined;
    emailId: string | undefined;
}

export class IterableWebhookBouncePayload implements IIterableWebhookBouncePayload {
    email!: string | undefined;
    userId!: string | undefined;
    eventName!: string | undefined;
    dataFields!: IterableWebhookBounceDataField | undefined;

    constructor(data?: IIterableWebhookBouncePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dataFields = data.dataFields && !(<any>data.dataFields).toJSON ? new IterableWebhookBounceDataField(data.dataFields) : <IterableWebhookBounceDataField>this.dataFields;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.eventName = _data["eventName"];
            this.dataFields = _data["dataFields"] ? IterableWebhookBounceDataField.fromJS(_data["dataFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IterableWebhookBouncePayload {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookBouncePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["eventName"] = this.eventName;
        data["dataFields"] = this.dataFields ? this.dataFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIterableWebhookBouncePayload {
    email: string | undefined;
    userId: string | undefined;
    eventName: string | undefined;
    dataFields: IIterableWebhookBounceDataField | undefined;
}

export class IterableWebhookPushNotificationPayload implements IIterableWebhookPushNotificationPayload {
    userId!: string | undefined;
    eventName!: string | undefined;
    dataFields!: IterableWebhookPushNotificationPayloadDataFields | undefined;

    constructor(data?: IIterableWebhookPushNotificationPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dataFields = data.dataFields && !(<any>data.dataFields).toJSON ? new IterableWebhookPushNotificationPayloadDataFields(data.dataFields) : <IterableWebhookPushNotificationPayloadDataFields>this.dataFields;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.eventName = _data["eventName"];
            this.dataFields = _data["dataFields"] ? IterableWebhookPushNotificationPayloadDataFields.fromJS(_data["dataFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IterableWebhookPushNotificationPayload {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookPushNotificationPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["eventName"] = this.eventName;
        data["dataFields"] = this.dataFields ? this.dataFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIterableWebhookPushNotificationPayload {
    userId: string | undefined;
    eventName: string | undefined;
    dataFields: IIterableWebhookPushNotificationPayloadDataFields | undefined;
}

export class IterableWebhookPushNotificationPayloadDataFields implements IIterableWebhookPushNotificationPayloadDataFields {
    platformEndpoint!: string | undefined;
    email!: string | undefined;
    createdAt!: string | undefined;
    campaignId!: number;
    templateId!: number;
    pushMessage!: string | undefined;
    campaignName!: string | undefined;
    workflowId!: number;
    workflowName!: string | undefined;
    templateName!: string | undefined;
    channelId!: number;
    messageTypeId!: number;
    experimentId!: number;
    payload!: IterableWebhookPushPayload | undefined;
    sound!: string | undefined;
    badge!: number;
    contentAvailable!: boolean;
    deeplink!: string | undefined;
    locale!: string | undefined;

    constructor(data?: IIterableWebhookPushNotificationPayloadDataFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.payload = data.payload && !(<any>data.payload).toJSON ? new IterableWebhookPushPayload(data.payload) : <IterableWebhookPushPayload>this.payload;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platformEndpoint = _data["platformEndpoint"];
            this.email = _data["email"];
            this.createdAt = _data["createdAt"];
            this.campaignId = _data["campaignId"];
            this.templateId = _data["templateId"];
            this.pushMessage = _data["pushMessage"];
            this.campaignName = _data["campaignName"];
            this.workflowId = _data["workflowId"];
            this.workflowName = _data["workflowName"];
            this.templateName = _data["templateName"];
            this.channelId = _data["channelId"];
            this.messageTypeId = _data["messageTypeId"];
            this.experimentId = _data["experimentId"];
            this.payload = _data["payload"] ? IterableWebhookPushPayload.fromJS(_data["payload"]) : <any>undefined;
            this.sound = _data["sound"];
            this.badge = _data["badge"];
            this.contentAvailable = _data["contentAvailable"];
            this.deeplink = _data["deeplink"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): IterableWebhookPushNotificationPayloadDataFields {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookPushNotificationPayloadDataFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformEndpoint"] = this.platformEndpoint;
        data["email"] = this.email;
        data["createdAt"] = this.createdAt;
        data["campaignId"] = this.campaignId;
        data["templateId"] = this.templateId;
        data["pushMessage"] = this.pushMessage;
        data["campaignName"] = this.campaignName;
        data["workflowId"] = this.workflowId;
        data["workflowName"] = this.workflowName;
        data["templateName"] = this.templateName;
        data["channelId"] = this.channelId;
        data["messageTypeId"] = this.messageTypeId;
        data["experimentId"] = this.experimentId;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["sound"] = this.sound;
        data["badge"] = this.badge;
        data["contentAvailable"] = this.contentAvailable;
        data["deeplink"] = this.deeplink;
        data["locale"] = this.locale;
        return data;
    }
}

export interface IIterableWebhookPushNotificationPayloadDataFields {
    platformEndpoint: string | undefined;
    email: string | undefined;
    createdAt: string | undefined;
    campaignId: number;
    templateId: number;
    pushMessage: string | undefined;
    campaignName: string | undefined;
    workflowId: number;
    workflowName: string | undefined;
    templateName: string | undefined;
    channelId: number;
    messageTypeId: number;
    experimentId: number;
    payload: IIterableWebhookPushPayload | undefined;
    sound: string | undefined;
    badge: number;
    contentAvailable: boolean;
    deeplink: string | undefined;
    locale: string | undefined;
}

export class IterableWebhookPushPayload implements IIterableWebhookPushPayload {
    path!: string | undefined;

    constructor(data?: IIterableWebhookPushPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): IterableWebhookPushPayload {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookPushPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        return data;
    }
}

export interface IIterableWebhookPushPayload {
    path: string | undefined;
}

export class IterableWebhookSubscribeDataFields implements IIterableWebhookSubscribeDataFields {
    createdAt!: string | undefined;
    signupSource!: string | undefined;
    emailListIds!: number[] | undefined;
    messageTypeIds!: number[] | undefined;
    channelIds!: number[] | undefined;
    email!: string | undefined;
    profileUpdatedAt!: string | undefined;

    constructor(data?: IIterableWebhookSubscribeDataFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"];
            this.signupSource = _data["signupSource"];
            if (Array.isArray(_data["emailListIds"])) {
                this.emailListIds = [] as any;
                for (let item of _data["emailListIds"])
                    this.emailListIds!.push(item);
            }
            if (Array.isArray(_data["messageTypeIds"])) {
                this.messageTypeIds = [] as any;
                for (let item of _data["messageTypeIds"])
                    this.messageTypeIds!.push(item);
            }
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
            this.email = _data["email"];
            this.profileUpdatedAt = _data["profileUpdatedAt"];
        }
    }

    static fromJS(data: any): IterableWebhookSubscribeDataFields {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookSubscribeDataFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt;
        data["signupSource"] = this.signupSource;
        if (Array.isArray(this.emailListIds)) {
            data["emailListIds"] = [];
            for (let item of this.emailListIds)
                data["emailListIds"].push(item);
        }
        if (Array.isArray(this.messageTypeIds)) {
            data["messageTypeIds"] = [];
            for (let item of this.messageTypeIds)
                data["messageTypeIds"].push(item);
        }
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        data["email"] = this.email;
        data["profileUpdatedAt"] = this.profileUpdatedAt;
        return data;
    }
}

export interface IIterableWebhookSubscribeDataFields {
    createdAt: string | undefined;
    signupSource: string | undefined;
    emailListIds: number[] | undefined;
    messageTypeIds: number[] | undefined;
    channelIds: number[] | undefined;
    email: string | undefined;
    profileUpdatedAt: string | undefined;
}

export class IterableWebhookSubscribePayload implements IIterableWebhookSubscribePayload {
    email!: string | undefined;
    userId!: string | undefined;
    eventName!: string | undefined;
    dataFields!: IterableWebhookSubscribeDataFields | undefined;

    constructor(data?: IIterableWebhookSubscribePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dataFields = data.dataFields && !(<any>data.dataFields).toJSON ? new IterableWebhookSubscribeDataFields(data.dataFields) : <IterableWebhookSubscribeDataFields>this.dataFields;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.eventName = _data["eventName"];
            this.dataFields = _data["dataFields"] ? IterableWebhookSubscribeDataFields.fromJS(_data["dataFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IterableWebhookSubscribePayload {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookSubscribePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["eventName"] = this.eventName;
        data["dataFields"] = this.dataFields ? this.dataFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIterableWebhookSubscribePayload {
    email: string | undefined;
    userId: string | undefined;
    eventName: string | undefined;
    dataFields: IIterableWebhookSubscribeDataFields | undefined;
}

export class IterableWebhookUnsubscribeDataFields implements IIterableWebhookUnsubscribeDataFields {
    campaignId!: number;
    messageId!: string | undefined;
    emailId!: string | undefined;
    workflowName!: string | undefined;
    messageTypeIds!: number[] | undefined;
    locale!: any | undefined;
    templateId!: number;
    emailSubject!: string | undefined;
    labels!: any[] | undefined;
    unsubSource!: string | undefined;
    createdAt!: string | undefined;
    templateName!: string | undefined;
    emailListIds!: number[] | undefined;
    messageTypeId!: number;
    experimentId!: any | undefined;
    channelIds!: number[] | undefined;
    campaignName!: string | undefined;
    workflowId!: number;
    email!: string | undefined;
    channelId!: number;

    constructor(data?: IIterableWebhookUnsubscribeDataFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"];
            this.messageId = _data["messageId"];
            this.emailId = _data["emailId"];
            this.workflowName = _data["workflowName"];
            if (Array.isArray(_data["messageTypeIds"])) {
                this.messageTypeIds = [] as any;
                for (let item of _data["messageTypeIds"])
                    this.messageTypeIds!.push(item);
            }
            this.locale = _data["locale"];
            this.templateId = _data["templateId"];
            this.emailSubject = _data["emailSubject"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.unsubSource = _data["unsubSource"];
            this.createdAt = _data["createdAt"];
            this.templateName = _data["templateName"];
            if (Array.isArray(_data["emailListIds"])) {
                this.emailListIds = [] as any;
                for (let item of _data["emailListIds"])
                    this.emailListIds!.push(item);
            }
            this.messageTypeId = _data["messageTypeId"];
            this.experimentId = _data["experimentId"];
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
            this.campaignName = _data["campaignName"];
            this.workflowId = _data["workflowId"];
            this.email = _data["email"];
            this.channelId = _data["channelId"];
        }
    }

    static fromJS(data: any): IterableWebhookUnsubscribeDataFields {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookUnsubscribeDataFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["messageId"] = this.messageId;
        data["emailId"] = this.emailId;
        data["workflowName"] = this.workflowName;
        if (Array.isArray(this.messageTypeIds)) {
            data["messageTypeIds"] = [];
            for (let item of this.messageTypeIds)
                data["messageTypeIds"].push(item);
        }
        data["locale"] = this.locale;
        data["templateId"] = this.templateId;
        data["emailSubject"] = this.emailSubject;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["unsubSource"] = this.unsubSource;
        data["createdAt"] = this.createdAt;
        data["templateName"] = this.templateName;
        if (Array.isArray(this.emailListIds)) {
            data["emailListIds"] = [];
            for (let item of this.emailListIds)
                data["emailListIds"].push(item);
        }
        data["messageTypeId"] = this.messageTypeId;
        data["experimentId"] = this.experimentId;
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        data["campaignName"] = this.campaignName;
        data["workflowId"] = this.workflowId;
        data["email"] = this.email;
        data["channelId"] = this.channelId;
        return data;
    }
}

export interface IIterableWebhookUnsubscribeDataFields {
    campaignId: number;
    messageId: string | undefined;
    emailId: string | undefined;
    workflowName: string | undefined;
    messageTypeIds: number[] | undefined;
    locale: any | undefined;
    templateId: number;
    emailSubject: string | undefined;
    labels: any[] | undefined;
    unsubSource: string | undefined;
    createdAt: string | undefined;
    templateName: string | undefined;
    emailListIds: number[] | undefined;
    messageTypeId: number;
    experimentId: any | undefined;
    channelIds: number[] | undefined;
    campaignName: string | undefined;
    workflowId: number;
    email: string | undefined;
    channelId: number;
}

export class IterableWebhookUnsubscribePayload implements IIterableWebhookUnsubscribePayload {
    email!: string | undefined;
    userId!: string | undefined;
    eventName!: string | undefined;
    dataFields!: IterableWebhookUnsubscribeDataFields | undefined;

    constructor(data?: IIterableWebhookUnsubscribePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dataFields = data.dataFields && !(<any>data.dataFields).toJSON ? new IterableWebhookUnsubscribeDataFields(data.dataFields) : <IterableWebhookUnsubscribeDataFields>this.dataFields;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.eventName = _data["eventName"];
            this.dataFields = _data["dataFields"] ? IterableWebhookUnsubscribeDataFields.fromJS(_data["dataFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IterableWebhookUnsubscribePayload {
        data = typeof data === 'object' ? data : {};
        let result = new IterableWebhookUnsubscribePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["eventName"] = this.eventName;
        data["dataFields"] = this.dataFields ? this.dataFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIterableWebhookUnsubscribePayload {
    email: string | undefined;
    userId: string | undefined;
    eventName: string | undefined;
    dataFields: IIterableWebhookUnsubscribeDataFields | undefined;
}

export enum OptStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class SettingsMessageTypeDto implements ISettingsMessageTypeDto {
    name!: string | undefined;
    messageTypeId!: number;
    visibleTitle!: string | undefined;
    settings!: CustomerSettingsDto | undefined;

    constructor(data?: ISettingsMessageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.settings = data.settings && !(<any>data.settings).toJSON ? new CustomerSettingsDto(data.settings) : <CustomerSettingsDto>this.settings;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.messageTypeId = _data["messageTypeId"];
            this.visibleTitle = _data["visibleTitle"];
            this.settings = _data["settings"] ? CustomerSettingsDto.fromJS(_data["settings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SettingsMessageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsMessageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["messageTypeId"] = this.messageTypeId;
        data["visibleTitle"] = this.visibleTitle;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISettingsMessageTypeDto {
    name: string | undefined;
    messageTypeId: number;
    visibleTitle: string | undefined;
    settings: ICustomerSettingsDto | undefined;
}

export class SettingsMessageTypeGroupDto implements ISettingsMessageTypeGroupDto {
    name!: string | undefined;
    description!: string | undefined;
    messageTypes!: SettingsMessageTypeDto[] | undefined;

    constructor(data?: ISettingsMessageTypeGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.messageTypes) {
                this.messageTypes = [];
                for (let i = 0; i < data.messageTypes.length; i++) {
                    let item = data.messageTypes[i];
                    this.messageTypes[i] = item && !(<any>item).toJSON ? new SettingsMessageTypeDto(item) : <SettingsMessageTypeDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["messageTypes"])) {
                this.messageTypes = [] as any;
                for (let item of _data["messageTypes"])
                    this.messageTypes!.push(SettingsMessageTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SettingsMessageTypeGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsMessageTypeGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.messageTypes)) {
            data["messageTypes"] = [];
            for (let item of this.messageTypes)
                data["messageTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISettingsMessageTypeGroupDto {
    name: string | undefined;
    description: string | undefined;
    messageTypes: ISettingsMessageTypeDto[] | undefined;
}

export class ShouldFetchNewPushPermissionDto implements IShouldFetchNewPushPermissionDto {
    fetchNewToken!: boolean;

    constructor(data?: IShouldFetchNewPushPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fetchNewToken = _data["fetchNewToken"];
        }
    }

    static fromJS(data: any): ShouldFetchNewPushPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShouldFetchNewPushPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fetchNewToken"] = this.fetchNewToken;
        return data;
    }
}

export interface IShouldFetchNewPushPermissionDto {
    fetchNewToken: boolean;
}

export class UnsubscribeMessageTypeDto implements IUnsubscribeMessageTypeDto {
    optStatus!: OptStatusEnum;
    messageTypeId!: number;
    groupTypeName!: string | undefined;

    constructor(data?: IUnsubscribeMessageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optStatus = _data["optStatus"];
            this.messageTypeId = _data["messageTypeId"];
            this.groupTypeName = _data["groupTypeName"];
        }
    }

    static fromJS(data: any): UnsubscribeMessageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnsubscribeMessageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optStatus"] = this.optStatus;
        data["messageTypeId"] = this.messageTypeId;
        data["groupTypeName"] = this.groupTypeName;
        return data;
    }
}

export interface IUnsubscribeMessageTypeDto {
    optStatus: OptStatusEnum;
    messageTypeId: number;
    groupTypeName: string | undefined;
}

export class VerifyBounceStatusResponse implements IVerifyBounceStatusResponse {
    hasBounced!: boolean;
    ignore!: boolean;
    openMessageTypeConsent!: boolean;

    constructor(data?: IVerifyBounceStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasBounced = _data["hasBounced"];
            this.ignore = _data["ignore"];
            this.openMessageTypeConsent = _data["openMessageTypeConsent"];
        }
    }

    static fromJS(data: any): VerifyBounceStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyBounceStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasBounced"] = this.hasBounced;
        data["ignore"] = this.ignore;
        data["openMessageTypeConsent"] = this.openMessageTypeConsent;
        return data;
    }
}

export interface IVerifyBounceStatusResponse {
    hasBounced: boolean;
    ignore: boolean;
    openMessageTypeConsent: boolean;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}